export const collapseAnimationDuration = 260;